const getters = {
  token: state => state.user.token,
  userName: state => state.user.userName,
  name: state => state.user.name,
  userId: state => state.user.userId,
  roles: state => state.user.roles,
  permissions: state => state.user.permissionList,
  introduce: state => state.user.introduce,
  routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  showStatus: state => state.user.showStatus,
  targetid: state => state.user.targetid,
  opened: state => {
    if (state.app.opened === 'false') {
      return false
    } else if (state.app.opened === 'true') {
      return true
    }
  },
  msgIsShow: state => state.app.msgIsShow
}
export default getters